export default "__VITE_ASSET__CeQ2P$xP__"